import { useTRPCAPI, useTRPCMutation } from '../../../../../trpc/trpc';

export const useCreateShareToken = () => {
  const trpcAPI = useTRPCAPI();
  return useTRPCMutation(trpcAPI.share.createShareToken.mutationOptions());
};
